<template>
  <div
    class="outer-container"
    :style="{
      background: pageData ? pageData.background_color : '',
      paddingBottom: paddingBottom ? paddingBottom + 'px' : '0',
    }"
  >
    <div v-if="pageData" class="editor-main" ref="editorMain">
      <div
        class="editor-main-module-box"
        v-for="item in pageData.module_list"
        :key="item.module_code"
      >
        <div
          class="editor-main-module"
          @click="() => handleReport(item, '0000')"
        >
          <component
            :is="`tms-${item.module_code}`"
            :isEditorStatus="false"
            :config="item"
            :theme="theme"
            :page-data="pageData"
            @report="
              ({ btn, type, params }) => handleReport(item, btn, type, params)
            "
          ></component>
        </div>
      </div>
      <div class="module-list-empty" v-if="pageData.module_list.length === 0">
        该内容暂未发布，请稍后
      </div>
    </div>
  </div>
</template>

<script>
import { Bridge } from "@mk/bridge";
import modList from "@/plugin/tms/mod-list";
import Utils from "@/js/util";

export default {
  props: ["pageData", "theme"],
  data() {
    return {};
  },
  created() {
    this.page_id = this.$route.query.page_id;
    if (this.page_id) {
      this.handleReport({ id: "0000" }, "0000", "p_show");
    }
    Utils.createRem();
    window.addEventListener("resize", this.reRender);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.reRender);
    });
  },
  computed: {
    bottomFloatIndex() {
      if (this.pageData) {
        const index = this.pageData.module_list.findIndex(
          (item) => item.module_code === "bottom_float"
        );
        return index;
      }
      return -1;
    },
    paddingBottom() {
      if (this.bottomFloatIndex !== -1) {
        return this.pageData.module_list[this.bottomFloatIndex].property_data
          .paddingBottom;
      }
      return 0;
    },
  },
  methods: {
    reRender() {
      Utils.createRem();
      this.$forceUpdate();
    },
    handleReport(component, btn, type = "u_click", params = {}) {
      /**
       * 平台： 0013
       * 页面： page_id
       * 组件： 自定义组建ID
       * 具体操作点： 0000 开始自定义
       */
      const page_id = this.pageData
        ? this.pageData.page_id
        : this.page_id || "";
      let componet_id = component.id;
      if (componet_id === undefined) {
        // 补充历史数据Id
        modList.base.forEach((item) => {
          if (item.module_code == component.module_code) {
            componet_id = item.id;
          }
        });
        modList.business.forEach((item) => {
          if (item.module_code == component.module_code) {
            componet_id = item.id;
          }
        });
        if (!componet_id) {
          return;
        }
      }
      componet_id = String(componet_id).padStart(4, 0);

      if (
        navigator.userAgent.indexOf("Mockuai") >= 0 ||
        navigator.userAgent.indexOf("Wdzg") >= 0
      ) {
        try {
          const bridge = new Bridge();
          bridge.ready((apis, bridge, env) => {
            bridge.callHandler("getUserInfo", {}, (res) => {
              if (res && res.data) {
                lib.storage.set("user", res.data);
              }
            });
          });
        } catch (err) {}
      }

      const user = lib.storage.get("user") || {};
      const data = {
        evt: type,
        type: type,
        page_id,
        tag: `${component.id}.${btn}`,
        trace_tag: `13.0000.${componet_id}.${btn}`,
        options: {
          page_id,
          ...params,
        },
        duration: "",
        route: this.$route.fullPath,
        time: new Date().getTime(),
        action_time: new Date().getTime(),
        a_route: "",
        mk_version: "1.0.0",
        a_scene: "",
        a_options: {},
        extend_options: {},
        user_agent: navigator.userAgent,
        language: navigator.language,
        net_type: this.getNetworkType(),
        net_connected: navigator.onLine,
        user_id: user.userId,
      };
      window.eventData = data || {};
    },
    getNetworkType() {
      var ua = navigator.userAgent;
      var networkStr = ua.match(/NetType\/\w+/)
        ? ua.match(/NetType\/\w+/)[0]
        : "NetType/other";
      networkStr = networkStr.toLowerCase().replace("nettype/", "");
      var networkType;
      switch (networkStr) {
        case "wifi":
          networkType = "wifi";
          break;
        case "4g":
          networkType = "4g";
          break;
        case "3g":
          networkType = "3g";
          break;
        case "3gnet":
          networkType = "3g";
          break;
        case "2g":
          networkType = "2g";
          break;
        default:
          networkType = "other";
      }
      return networkType;
    },
  },
};
</script>

<style lang="scss" scoped>
.dnd-placeholder {
  width: 100%;
  height: 45px;
  background: url(../../../assets/placeholder.png) no-repeat center;
  background-size: cover;
  text-indent: -9999em;

  * {
    display: none;
  }
}

.outer-container {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.editor-main {
  position: relative;
  left: 0;
  height: 100%;
  //overflow-x: hidden;
  //overflow-y: scroll;
}

.editor-main::-webkit-scrollbar {
  display: none;
}

.module-list-empty {
  width: 373px;
  text-align: center;
  line-height: 665px;
  font-size: 16px;
}

.editor-main-module-box {
  width: 100%;
  cursor: pointer;
  position: relative;
  margin: 0 auto;
}

.module-action-box {
  position: absolute;
  top: 0px;
  right: 5px;
  z-index: 100;
}
</style>
